import VueCharts  from 'vue-chartjs'
export default {
    extends: VueCharts.Bar,
    data: () => ({
        labels: [],
        certificados: [],
        noCertificados: []
    }),
    mounted() {
        var self = this
        self.$ajax.get('/CERTIFIED_SCHOOLS/GetCertifiedAndNotCertifiedSchoolsCountByRegionAsync').then(response => {

            for (var i = 0; i < response.data.length; i++) {
                self.labels.push(response.data[i].REGION_NAME)
                self.certificados.push(response.data[i].CERTIFIED)
                self.noCertificados.push(response.data[i].NOT_CERTIFIED)
            }

            self.renderChart({
                labels: self.labels,
                datasets: [
                    {
                        label: 'Certificados',
                        backgroundColor: '#e6b400',
                        data: self.certificados
                    },
                    {
                        label: 'No Certificado',
                        backgroundColor: '#dce775',
                        data: self.noCertificados
                    }
                ]
            }, {
                    scales: {
                        xAxes: [{
                            stacked: true
                        }],
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            },
                            stacked: true
                        }]
                    },
                    responsive: true,
                    responsiveAnimationDuration: 1000,
                    maintainAspectRatio: false,
                    tooltips: {
                        callbacks: {
                            label: (tooltipItem, data) => {
                                var dataset = data.datasets[tooltipItem.datasetIndex]
                                var currentValue = dataset.data[tooltipItem.index]
                                var total = 0
                                var theOtherDatasetValue = 0
                                //Certificados
                                if (tooltipItem.datasetIndex == 0) {
                                    theOtherDatasetValue = data.datasets[1].data[tooltipItem.index]
                                }
                                //No Certificado
                                else {
                                    theOtherDatasetValue = data.datasets[0].data[tooltipItem.index]
                                }

                                total = currentValue + theOtherDatasetValue
                                
                                var percentage = Math.floor(((currentValue / total) * 100) + 0.5)
                                return percentage + "%"
                            }
                        }
                    }
                })
        }).catch(response => {
            self.$root.$snackbar('Ha ocurrido un error mientras se trataba de cargar los datos.', { color: 'error' })
        })
    }
}


// WEBPACK FOOTER //
// ./src/components/graduados/reportes/escuelasCertificadas.js